import { render, staticRenderFns } from "./GroupBuyList.vue?vue&type=template&id=5d8c5f94&scoped=true"
import script from "./GroupBuyList.vue?vue&type=script&lang=js"
export * from "./GroupBuyList.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyList.vue?vue&type=style&index=0&id=5d8c5f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c5f94",
  null
  
)

export default component.exports